import { render } from "./view-cover-area.vue?vue&type=template&id=44bc4838&scoped=true"
import script from "./view-cover-area.vue?vue&type=script&lang=js"
export * from "./view-cover-area.vue?vue&type=script&lang=js"

import "./view-cover-area.vue?vue&type=style&index=0&id=44bc4838&lang=less&scoped=true"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bc4838"]])

export default __exports__